<template>
  <div class="mission__item">
    <MissionsListOneInfo
      :key="index"
      :missionData="missionData"
      :index="index"
      :progress="getMissionProgress"
    />
  </div>
</template>
<script>
import MissionsListOneInfo from "./MissionsListOneInfo";

export default {
  name: "MissionsListItem",
  components: {
    MissionsListOneInfo,
  },
  props: {
    missionData: Object,
    index: Number,
  },
  computed: {
    getMissionProgress() {
      let progress = this.missionData.progress,
        target_count = this.missionData.target_count;

      return progress >= target_count ? target_count : progress;
    },
  },
};
</script>
